import gql from 'graphql-tag';

import OffersFragment from './fragments/offers';

export default gql`
  query GetAllAppData {
    allAppData(limit: 1) {
      _id
      cateringSection {
        _id
      }
      sodiumDisclaimer {
        localeRaw: _LANG_Raw
      }
      priceDisclaimer {
        locale: _LANG_
      }
      imagesDisclaimer {
        locale: _LANG_
      }
      headerText
      appHeaderText
    }
  }
`;

export const sortedOffersQuery = gql`
  query AllAppData {
    allAppData(limit: 1) {
      _id
      sortedOffers {
        ...OffersFragment
      }
    }
  }
  ${OffersFragment}
`;
